module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/numero_verde.44739362.png";